const ME = {
  ibanLength: 22,
};
export { ME };
